<template>
  <div class="form" style="text-align:left;">
    <div class="title is-4">{{ title }}</div>


    <div class="columns">
      <div class="column" style="text-align:left;">
        <b-field label="Name">
          <b-input maxlength="255" v-model="item.name"></b-input>
        </b-field>
      </div>
      <div class="column">
        <b-field label="Bild">
          <b-input maxlength="255" v-model="item.image"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half" style="text-align:left;">
        <label class="label">Beschreibung</label>
        <VueTrix maxlength="255" v-model="item.description" placeholder="Beschreibung einfügen"/>
      </div>
      <div class="column is-half">
        <b-field label="Code">
          <b-input maxlength="255" v-model="item.code"></b-input>
        </b-field>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half" style="text-align:left;">
        <b-field label="Conversion Fallback" message="Fallback, falls kein mengen-spezifischer Wert hinterlegt ist">
          <b-input maxlength="255" v-model="item.conversion"></b-input>
        </b-field>
        <b-field label="Conversion Gruppe 0-299">
          <b-input maxlength="255" v-model="item.conversion0To299"></b-input>
        </b-field>
        <b-field label="Conversion Gruppe 300-999">
          <b-input maxlength="255" v-model="item.conversion300To999"></b-input>
        </b-field>
        <b-field label="Conversion Gruppe 1.000-2.999">
          <b-input maxlength="255" v-model="item.conversion1000To2999"></b-input>
        </b-field>
        <b-field label="Conversion Gruppe ab 3.000">
          <b-input maxlength="255" v-model="item.conversion3000Plus"></b-input>
        </b-field>
      </div>
    </div>


    <div class="columns">
      <div class="column" style="text-align:right;">
        <b-button type="is-primary" v-on:click="save()" :disabled="loading">Speichern</b-button>
      </div>
    </div>

  </div>
</template>


<script>
// @ is an alias to /src


import Vue from 'vue'
import VueTrix from "vue-trix";

const axios = require('axios');


export default {
  name: "home",
  components: {
    VueTrix
  },
  data() {
    return {
      title: "Neue Spielart anlegen",
      item: {},
      loading: true
      //  item: { 'id': 22, 'name': 'Beidseitig individuelles Kartenset', 'spielart': 'Kartenspiel', 'date': '2016-10-15 13:43:27' },
    }
  },
  watch: {},
  mounted: function () {
    console.log("FORM " + this.$route.params.id);
    if (this.$route.params.id) {
      this.title = "Spielart bearbeiten";
      //Get-Game
      var _this = this;
      axios.get('/api/categories/' + this.$route.params.id, {
        withCredentials: true,
      })
          .then(function (response) {
            console.log(response.data);
            _this.item = response.data;
            _this.loading = false;

          })
          .catch(function (error) {
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    } else {
      this.loading = false;
    }

  },
  methods: {
    save: function () {
      if ((this.item.name) && (this.item.description) && (this.item.image) && (this.item.code) && (this.item.conversion)) {

        //Set-Package
        var _this = this;
        var url = '/api/categories';


        console.log("SAVE");
        console.log(url);
        console.log(this.item);

        axios.post(url, this.item, {
          headers: {
            'Content-Type': 'application/json',
          },
          withCredentials: true,
        })
            .then(function (response) {
              console.log(response.data);
              _this.$router.push({name: 'categories'})
            })
            .catch(function (error) {
              console.log(error);
            })
            .then(function () {
              // always executed
            });

      } else {
        console.log("Alle Felder ausfüllen");
        this.$buefy.dialog.alert({
          title: 'Fehler',
          message: 'Bitte füllen Sie alle Felder aus.',
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert-circle',
          iconPack: 'mdi'
        });

      }

    }
  }
};

</script>
